import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import moment, { Moment } from 'moment';

export class DateValidators {
	static between(start_date: Moment, end_date: Moment): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control.value == null) {
				return null;
			}

			const control_date = moment(control.value, 'YYYY-MM-DD');

			if (!control_date.isValid()) {
				return null;
			}

			if (
				start_date.isValid() &&
				end_date.isValid() && (
				control_date.isBefore(start_date) ||
				control_date.isAfter(end_date)
			)) {
				return {
					valid: false,
				}
			}

			return null;
		}
	}
}
